import styled from 'styled-components';
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';

/* Modal Styles */
export const ResultsModalContainer = styled(Modal)`
    --results-surface: var(--surface-color);
    --results-surface-raised: var(--raised-surface-color);
    --results-surface-field: var(--field-surface-color);
    --results-border: var(--border-color);
    --results-accent: var(--accent-color);
    --results-accent-dark: var(--text-color);

    .modal-content {
        //background: var(--results-surface);
        background: white;
        border: 1px solid var(--results-border);
        color: var(--text-color);
        overflow: hidden;
    }

    .modal-footer {
        background: var(--results-surface-raised);
        border-top-color: var(--results-border);
    }

    .form-control,
    .form-select {
        background-color: var(--results-surface-field);
        border-color: #d9cba9;
    }

    .form-control:focus,
    .form-select:focus {
        background-color: #fffdf7;
        border-color: var(--results-accent);
        box-shadow: 0 0 0 0.2rem rgba(212, 160, 23, 0.18);
    }

    .form-control:disabled {
        background-color: #eee7d6;
        color: var(--muted-text-color);
    }

    .alert-info {
        background-color: #fff3cd;
        border-color: #e8cf7a;
        color: var(--text-color);
    }

    .btn-primary,
    .btn-info,
    .btn-warning {
        background-color: var(--results-accent);
        border-color: var(--results-accent);
        color: #171717;
    }

    .btn-primary:hover,
    .btn-primary:focus,
    .btn-info:hover,
    .btn-info:focus,
    .btn-warning:hover,
    .btn-warning:focus {
        background-color: var(--accent-hover-color);
        border-color: var(--accent-hover-color);
        color: #171717;
    }

    @media (max-width: 575px) {
        .modal-dialog {
            margin: 0.5rem;
            max-height: calc(100dvh - 1rem);
        }

        .modal-content {
            max-height: calc(100dvh - 1rem);
        }

        .modal-footer {
            padding: 0.55rem 0.75rem;
        }
    }
`;

export const ResultsModalHeading = styled.h2`
    font-size: 2rem;
    font-weight: 700;
    color: var(--text-color);
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-bottom: 0.5rem;

    @media (max-width: 575px) {
        font-size: 1.45rem;
        margin-bottom: 0.35rem;
    }
`;

export const ResultsModalBody = styled(Modal.Body)`
    padding: 1.25rem 1.25rem 1.5rem;
    //background: var(--results-surface);
    background: white;

    @media (min-width: 992px) {
        padding: 1.5rem 1.75rem 1.75rem;
    }

    @media (max-width: 575px) {
        padding: 0.65rem 0.7rem 0.85rem;
    }
`;

export const ResultsModalHero = styled.div`
    //background: var(--results-surface-raised);
    background: #FFDF8B80;
    border: 1px solid var(--results-border);
    //border-left: 4px solid var(--results-accent);
    border-left: 0;
    border-radius: 16px;
    padding: 1rem 1.1rem;
    margin-bottom: 1rem;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);

    @media (max-width: 575px) {
        border-radius: 12px;
        margin-bottom: 0.7rem;
        padding: 0.75rem;

        > p:nth-child(2) {
            font-size: 0.88rem !important;
            line-height: 1.35;
            margin-bottom: 0.55rem !important;
        }

        .row {
            --bs-gutter-x: 0.45rem;
            --bs-gutter-y: 0.45rem;
        }
    }
`;

export const ResultsModalSection = styled.div`
    //background: var(--results-surface-raised);
    background: #FFDF8B80;
    border: 1px solid var(--results-border);
    border-radius: 16px;
    padding: 1rem 1.1rem;
    margin-bottom: 1rem;
    box-shadow: 0 8px 22px rgba(120, 92, 20, 0.05);

    @media (max-width: 575px) {
        border-radius: 12px;
        margin-bottom: 0.7rem;
        padding: 0.75rem;
    }
`;

export const ResultsModalDetailsSection = styled.section`
    //background: var(--results-surface-raised);
    background: #FFDF8B80;
    border: 1px solid var(--results-border);
    border-radius: 16px;
    box-shadow: 0 8px 22px rgba(120, 92, 20, 0.05);
    margin-bottom: 1rem;
    padding: 0.85rem 1.1rem;

    @media (max-width: 575px) {
        border-radius: 12px;
        margin-bottom: 0.7rem;
        padding: 0.7rem 0.75rem;
    }
`;

export const ResultsModalDetailsHeading = styled.h3`
    color: #171717;
    font-size: 0.95rem;
    font-weight: 700;
    margin-bottom: 0.45rem;
`;

export const ResultsModalDetailsGrid = styled.dl`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 1.5rem;
    margin: 0;

    @media (max-width: 767px) {
        grid-template-columns: 1fr;
    }
`;

export const ResultsModalDetailItem = styled.div`
    align-items: baseline;
    border-bottom: 1px solid #eadfc8;
    display: flex;
    font-size: 0.84rem;
    gap: 0.75rem;
    justify-content: space-between;
    min-width: 0;
    padding: 0.38rem 0;

    dt {
        color: var(--muted-text-color);
        font-weight: 400;
        margin: 0;
    }

    dd {
        color: #171717;
        flex-shrink: 0;
        font-weight: 700;
        margin: 0;
        text-align: right;
    }

    @media (max-width: 575px) {
        font-size: 0.78rem;
        gap: 0.45rem;
        padding: 0.32rem 0;

        dt {
            min-width: 0;
        }

        dd {
            overflow-wrap: anywhere;
        }
    }
`;

export const ResultsModalDetailsNote = styled.p`
    color: var(--muted-text-color);
    font-size: 0.76rem;
    line-height: 1.4;
    margin: 0.65rem 0 0;
`;

export const ResultsModalMetricCard = styled.div`
    background: var(--results-surface-field);
    border: 1px solid #ead9ae;
    border-radius: 14px;
    padding: 0.9rem;
    height: 100%;
    backdrop-filter: blur(4px);

    @media (max-width: 991px) {
        padding: 0.65rem 0.5rem;

        > div:first-child {
            font-size: 0.7rem !important;
        }

        > div:last-child {
            font-size: 1.05rem !important;
        }
    }

    @media (max-width: 575px) {
        border-radius: 8px;
        min-height: 76px;
        padding: 0.55rem 0.45rem;

        > div:first-child {
            font-size: 0.64rem !important;
        }

        > div:last-child {
            font-size: 0.95rem !important;
            line-height: 1.2;
            overflow-wrap: anywhere;
        }
    }
`;

export const ResultsModalComparisonGrid = styled.div`
    display: grid;
    grid-auto-columns: minmax(165px, 1fr);
    grid-auto-flow: column;
    gap: 0.75rem;
    overflow-x: auto;
    padding: 0.15rem 0 0.35rem;

    @media (max-width: 991px) {
        grid-auto-flow: row;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 0.5rem;
        overflow-x: visible;
    }

    @media (max-width: 575px) {
        grid-auto-flow: row;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 0.4rem;
        overflow-x: visible;
    }
`;

export const ResultsModalComparisonCard = styled.button`
    appearance: none;
    background: ${({ $selected }) => ($selected ? 'var(--results-surface-field)' : 'var(--results-surface-field)')};
    border: 4px solid ${({ $selected }) => ($selected ? 'var(--results-accent)' : '#e2d5b7')};
    border-radius: 8px;
    color: #171717;
    min-height: 168px;
    padding: 0.9rem;
    text-align: left;
    transition: border-color 160ms ease, background-color 160ms ease, transform 160ms ease;

    &:hover:not(:disabled),
    &:focus-visible {
        background: #fff7db;
        border-color: var(--results-accent);
        outline: none;
        transform: translateY(-2px);
    }

    &:focus-visible {
        box-shadow: 0 0 0 0.2rem rgba(212, 160, 23, 0.2);
    }

    &:disabled {
        cursor: wait;
        opacity: 0.68;
    }

    @media (max-width: 991px) {
        min-height: 150px;
        min-width: 0;
        padding: 0.65rem 0.5rem;
    }

    @media (max-width: 575px) {
        min-height: 158px;
        min-width: 0;
        padding: 0.55rem 0.45rem;
    }
`;

export const ResultsModalComparisonLabel = styled.span`
    color: var(--results-accent-dark);
    display: block;
    font-size: 1.05rem;
    font-weight: 700;
    margin-bottom: 0.7rem;

    @media (max-width: 991px) {
        font-size: 0.92rem;
        margin-bottom: 0.5rem;
    }

    @media (max-width: 575px) {
        font-size: 0.88rem;
        margin-bottom: 0.45rem;
    }
`;

export const ResultsModalComparisonValue = styled.span`
    display: flex;
    font-size: 0.82rem;
    justify-content: space-between;
    gap: 0.5rem;
    padding: 0.22rem 0;

    strong {
        font-weight: 700;
        text-align: right;
    }

    @media (max-width: 991px) {
        font-size: 0.74rem;
        padding: 0.16rem 0;
    }

    @media (max-width: 575px) {
        align-items: flex-start;
        flex-direction: column;
        font-size: 0.68rem;
        gap: 0.05rem;
        padding: 0.14rem 0;

        strong {
            overflow-wrap: anywhere;
            text-align: left;
        }
    }
`;

export const ResultsModalSelectedLabel = styled.span`
    color: var(--results-accent-dark);
    display: block;
    font-size: 0.75rem;
    font-weight: 700;
    margin-top: 0.55rem;
    text-transform: uppercase;

    @media (max-width: 991px) {
        font-size: 0.58rem;
        line-height: 1.15;
        margin-top: 0.3rem;
    }

    @media (max-width: 575px) {
        font-size: 0.62rem;
        line-height: 1.2;
        margin-top: 0.35rem;
    }
`;

export const ResultsModalContactForm = styled.form`
    //background: var(--results-surface-raised);
    background: #FFDF8B80;
    border: 1px solid var(--results-border);
    border-radius: 16px;
    padding: 0.85rem 1rem;

    .row {
        --bs-gutter-x: 0.75rem;
        --bs-gutter-y: 0.55rem;
    }

    .form-label {
        color: var(--text-color);
        font-size: 0.78rem;
        font-weight: 600;
        margin-bottom: 0.2rem;
    }

    .form-control,
    .form-select {
        font-size: 0.84rem;
        min-height: 32px;
        padding: 0.28rem 0.55rem;
    }

    .invalid-feedback,
    .valid-feedback {
        font-size: 0.72rem;
    }

    @media (max-width: 575px) {
        border-radius: 12px;
        padding: 0.7rem 0.75rem;

        .row {
            --bs-gutter-x: 0.5rem;
            --bs-gutter-y: 0.5rem;
        }

        .form-control,
        .form-select {
            min-height: 42px;
        }
    }
`;

export const ResultsModalFormBlock = styled.fieldset`
    border: 0;
    margin: 0;
    padding: 0 0 0.8rem;

    & + & {
        border-top: 1px solid var(--results-border);
        padding-top: 0.8rem;
    }
`;

export const ResultsModalFormLegend = styled.legend`
    color: #171717;
    font-size: 0.92rem;
    font-weight: 700;
    margin-bottom: 0.15rem;
`;

export const ResultsModalFormHint = styled.p`
    color: var(--muted-text-color);
    font-size: 0.78rem;
    margin-bottom: 0.55rem;
`;

export const ResultsModalFormActions = styled.div`
    align-items: center;
    border-top: 1px solid var(--results-border);
    display: grid;
    gap: 0.75rem 1rem;
    grid-template-columns: minmax(220px, 0.7fr) 1.3fr;
    padding-top: 0.8rem;

    .alert {
        grid-column: 1 / -1;
        margin: 0 !important;
    }

    @media (max-width: 767px) {
        grid-template-columns: 1fr;
    }
`;

export const ResultsModalPrivacyNote = styled.p`
    color: var(--muted-text-color);
    font-size: 0.7rem;
    line-height: 1.35;
    margin: 0;
`;

export const PdfButton = styled(Button)`
    width: 100%;
    border-radius: 999px;
    font-weight: 600;

    @media (max-width: 575px) {
        min-height: 44px;
    }
`;

export const AddressInput = styled.input`
    width: 100%;
    margin-bottom: 10px;
`;

export const AddressButton = styled(Button)`
    width: 100%;
    min-height: 32px;
    padding: 0.28rem 0.65rem;
    font-size: 0.82rem;
    border-radius: 999px;

    @media (min-width: 576px) {
        width: 100%;
        font-size: 0.82rem;
    }

    @media (max-width: 575px) {
        min-height: 42px;
    }
`;

export const ModalButton = styled(Button)``;

/* Assumptions Modal */
export const AssumptionModalBody = styled.div`
    margin: 3%;

    h2 {
        font-weight: bolder;
    }
`;

/* Icon and Footer Styles */
export const AppIconImageBox = styled.div`
    width: 100%;
    height: auto;
    display: inline-flex;
    justify-content: center;
    margin-top: 5%;
    margin-bottom: 5%;
`;

export const Footer = styled.div`
    display: inline-flex;
    align-self: flex-end;
    justify-content: center;
    align-items: center;
    height: 60px;
    color: #171717;
    position: relative;
    bottom: 0;
    left: 0;
    width: 100%;

    h4 {
        font-size: 1rem;
    }
`;

export const IconRow = styled.div`
    display: inline-flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
`;

export const ModalIconRow = styled.div`
    display: inline-flex;
    width: 100%;
    justify-content: flex-end;
    padding-right: 5%;
    margin-top: 5%;

    p {
        margin-right: 1%;
    }
`;
